import { formatDistanceToNow } from "date-fns";
import { CardHeader } from "../ui/card";
import { Clock, QrCode } from "lucide-react";
import { Order } from "@/types/orders";
import { formatCurrency } from "@/lib/currencyFormatter";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { PaymentMethodBadge } from "./PaymentMethodBadge";
import { useTranslation } from "react-i18next";



export const OrderHeader = ({
    order,
    showPaymentStatus,
    handleConfirmPayment = undefined,
}: {
    order: Order;
    showPaymentStatus: boolean;
    handleConfirmPayment?: (e: React.MouseEvent) => Promise<void> | undefined;
}) => {
    const { t } = useTranslation();
    const totalQuantity = order.items.reduce(
        (sum, item) => sum + item.quantity,
        0
      );
      
  return (
    <CardHeader className="p-3 sm:p-4 text-xs sm:text-sm bg-gradient-to-r from-gray-50 to-gray-100 border-b">
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
      <div className="flex items-center gap-2">
        <div className="bg-primary/10 p-1.5 sm:p-2 rounded-full">
          <QrCode className="h-4 w-4 sm:h-5 sm:w-5 text-primary" />
        </div>
        <div>
          <h3 className="font-bold text-sm sm:text-base">
            {t("order")} #{order.id.slice(0, 8)}
          </h3>
          <div className="flex items-center text-xs sm:text-sm text-muted-foreground">
            <Clock className="h-3 w-3 mr-1" />
            {formatDistanceToNow(new Date(order.createdAt), {
              addSuffix: true,
            })}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 justify-between sm:justify-between ">
        <div className="text-right w-full">
          <div className="font-bold text-base sm:text-lg">
            {formatCurrency(order.totalAmount)}
          </div>
          <div className="flex sm:flex-row justify-between gap-2 w-full">
            <Badge variant="outline" className="bg-gray-100 text-xs sm:text-sm">
              {totalQuantity} {totalQuantity === 1 ? t("item") : t("items")}
            </Badge>
            {showPaymentStatus && order.payment_method === 'Cash' && !order.is_payed && (
              <Button size="sm" variant="outline" className="text-orange-700 border-orange-300 text-xs sm:text-sm" onClick={handleConfirmPayment}>
                {t('confirmPayment')}
              </Button>
            )}
            {showPaymentStatus && order.payment_method === 'Cash' && order.is_payed && (
              <Badge variant="outline" className="bg-green-100 text-green-800 border-green-200">
                {t('paid')}
              </Badge>
            )}
            {showPaymentStatus && order.payment_method !== 'Cash' && (
              <Badge
                variant="outline"
                className={
                  order.is_payed
                    ? 'bg-green-100 text-green-800 border-green-200'
                    : 'bg-yellow-100 text-yellow-800 border-yellow-200'
                }
              >
                {order.is_payed ? t('paid') : t('unpaid')}
              </Badge>
            )}
            {order.payment_method && <PaymentMethodBadge method={order.payment_method} />}
          </div>
        </div>
      </div>
    </div>
  </CardHeader>

  );
};